export function showToast(message: string, durationMs = 4200): void {
  let host = document.querySelector('.ev123-toast-host') as HTMLElement | null;
  if (!host) {
    host = document.createElement('div');
    host.className = 'ev123-toast-host';
    document.body.appendChild(host);
  }
  const t = document.createElement('div');
  t.className = 'ev123-toast';
  t.textContent = message;
  host.appendChild(t);
  window.setTimeout(() => {
    t.remove();
    if (host && host.childElementCount === 0) host.remove();
  }, durationMs);
}

export function showModal(options: {
  title: string;
  body: string;
  /** 본문 대신 커스텀 블록(긴 텍스트·갤러리 등). 지정 시 `body`는 무시됩니다. */
  bodyElement?: HTMLElement;
  confirmLabel?: string;
  onClose?: () => void;
}): void {
  const backdrop = document.createElement('div');
  backdrop.className = 'ev123-modal-backdrop';
  backdrop.setAttribute('role', 'dialog');
  backdrop.setAttribute('aria-modal', 'true');

  const modal = document.createElement('div');
  modal.className = 'ev123-modal';

  const title = document.createElement('h2');
  title.className = 'ev123-modal__title';
  title.textContent = options.title;

  const body = document.createElement('div');
  body.style.margin = '0';
  body.style.color = 'var(--ev123-muted)';
  body.style.fontSize = '0.95rem';
  if (options.bodyElement) {
    body.appendChild(options.bodyElement);
  } else {
    const p = document.createElement('p');
    p.style.margin = '0';
    p.textContent = options.body;
    body.appendChild(p);
  }

  const actions = document.createElement('div');
  actions.className = 'ev123-modal__actions';

  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'ev123-btn ev123-btn--primary ev123-btn--sm';
  btn.textContent = options.confirmLabel ?? '확인';

  const close = (): void => {
    backdrop.remove();
    options.onClose?.();
  };

  btn.addEventListener('click', close);
  backdrop.addEventListener('click', (e) => {
    if (e.target === backdrop) close();
  });

  actions.appendChild(btn);
  modal.append(title, body, actions);
  backdrop.appendChild(modal);
  document.body.appendChild(backdrop);
  btn.focus();
}
